import { useState } from 'react';
import { allStores } from '@/mock/mockStores';
import DataTable from '@/components/features/data-table/DataTable';
import { useStoreList } from '@/services/Store/storeService';
import { useNavigate } from 'react-router-dom';
import { StatusTag } from '@/components/common/StatusTag/StatusTag';

const StoresTable = () => {
  const navigate = useNavigate();

  const columns = [
    {
      columnKey: 'storeName',
      header: 'STORE NAME',
      cellData: ctx => {
        const storeName = ctx.row.original.storeName;
        return storeName ? storeName : '-';
      }
    },
    {
      columnKey: 'storeId',
      header: 'STORE ID',
      cellData: ctx => {
        const storeId = ctx.row.original.storeId;
        return storeId ? (
          <span
            style={{
              cursor: 'pointer',
              color: '#66A5E7',
              textDecoration: 'none'
            }}
            onClick={e => {
              console.log('ctx.row.original.storeId', storeId);
              e.stopPropagation(); // Prevent row click from firing
              navigate(`/profile/store/${storeId}`);
            }}>
            {storeId}
          </span>
        ) : (
          '-'
        );
      }
    },
    {
      columnKey: 'customerId',
      header: 'CUSTOMER ID',
      cellData: ctx => {
        const customerId = ctx.row.original.customerId;
        return customerId ? (
          <span
            style={{
              cursor: 'pointer',
              color: '#66A5E7',
              textDecoration: 'none'
            }}
            onClick={e => {
              e.stopPropagation(); // Prevent row click from firing
              navigate(`/profile/customer/${customerId}`);
            }}>
            {customerId}
          </span>
        ) : (
          '-'
        );
      }
    },
    {
      columnKey: 'activeStatus',
      header: 'STATUS',
      cellData: ctx => {
        const statusValue = ctx.row.original.activeStatus;
        if (!statusValue || statusValue === 'INACTIVE') {
          return (
            <StatusTag
              text='Inactive'
              color='red'
              className={'!ml-0 max-w-[62px]'}
            />
          );
        }
        return <span>Active</span>;
      }
    },
    // {
    //   columnKey: 'deliveryDays',
    //   header: 'DELIVERY DAYS',
    //   cellData: ctx => {
    //     const deliveryDays = ctx.row.original.deliveryDays;
    //     return deliveryDays ? deliveryDays.join(', ') : '-';
    //   }
    // },
    // {
    //   columnKey: 'cutoffTime',
    //   header: 'CUTOFF TIME',
    //   cellData: ctx => {
    //     const cutoffTime = ctx.row.original.cutoffTime;
    //     return cutoffTime ? cutoffTime : '-';
    //   }
    // },
    {
      columnKey: 'points',
      header: 'CURRENT POINTS',
      cellData: ctx => {
        const points = ctx.row.original.points;
        return points ? points : '-';
      }
    }
  ];

  return (
    <DataTable
      tableHeader='Stores'
      columns={columns}
      isDark={true}
      showColumnFilters={true}
      onSettingsClicked={() => alert('Settings clicked')}
      selection='multiple'
      idField='storeId'
      pageSize={10}
      enableSorting={true}
      fetchFunction={useStoreList}
      downloadFileName='storeview_MX_data.csv'
    />
  );
};

export default StoresTable;
